var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageCompare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6941 0.5V4.26119M14.6941 36.5V32.2015M14.6941 4.26119H5.55982C4.48519 4.26119 2.33594 4.90597 2.33594 7.48507V30.0522C2.51504 30.9478 3.41056 32.6313 5.55982 32.2015H14.6941M14.6941 4.26119V32.2015M17.3807 4.26119H25.4404C26.515 4.26119 28.6643 4.90597 28.6643 7.48507V24.1418M28.6643 24.1418V27.903C28.4852 29.1567 27.0524 32.6313 24.9031 32.2015H19.53V15.5448L28.6643 24.1418ZM12.5449 17.694L6.63444 26.8284H12.5449V17.694Z",
    stroke: "#5627D9",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCompare);
export default __webpack_public_path__ + "static/media/image-compare.6b8470577eeeb9ca91aa9c7e87e82081.svg";
export { ForwardRef as ReactComponent };